module.exports = __webpack_public_path__ + "static/img/fivetigers_en.2de340c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/fivetigers_en.png
// module id = bgoN
// module chunks = 1